import { Button, InputNumber, Spin, message, Tag, Modal, Input, Tabs, Select, Switch } from 'antd';
import React, { useState } from 'react'
import { useCallback, useEffect } from 'react';


import { format } from '../../App';
import MenuBar from '../menu/MenuBar';

import { useSelector, useDispatch } from 'react-redux';
import { gotoMakePDF } from '../account/gotoPDF';
import { useHistory } from 'react-router-dom';
import { delUser, setUser } from '../../app/features/user/userSlice';
import moment from 'moment';

import { postData, countCanclePolicy, pad, getOptionDriver } from '../../data/allfunction';

import PDFReport from './PDFReport_2';
import { PDFDownloadLink } from '@react-pdf/renderer';
import MakeDocLong from '../pdf/MakeDocLong';
import MakeDocSafty from '../pdf/MakeDocSafty';
import ShowModalPolicy from '../modalPolicy/ShowModalPolicy';


const dateFormat = 'DD-MM-YYYY HH:mm:ss'
const ip = process.env.REACT_APP_IP
const QR = process.env.REACT_APP_QR
const { TextArea } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

function ConfirmPaid() {
    const history = useHistory()
    const dispatch = useDispatch()
    const { user_id, user, token, retoken, level } = useSelector(state => {
        return state.user
    })

    const [policy_no, setpolicy_no] = useState(0)
    const [loading, setloading] = useState(false)
    const [oneData, setoneData] = useState({})
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detial, setdetial] = useState('');
    const [no, setno] = useState(null);


    const [policy_no_start, setpolicy_no_start] = useState(0)
    const [policy_no_end, setpolicy_no_end] = useState(0)
    const [datas, setdatas] = useState([])

    const [users, setUsers] = useState([])
    const [sent_user, setsent_user] = useState()
    const [sent_user_name, setsent_user_name] = useState('')


    const [enablePayLate, setenablePayLate] = useState(false);
    const [detialPaylate, setdetialPaylate] = useState('');


    const [premuim_ConfirmS, setpremuim_ConfirmS] = useState(0)
    const [total_premuim_ConfirmS, settotal_premuim_ConfirmS] = useState(0)
    const [commission_ConfirmS, setcommission_ConfirmS] = useState(0)
    const [ZJIIncom_ConfirmS, setZJIIncom_ConfirmS] = useState(0)
    const [total_zji_get_ConfirmS, settotal_zji_get_ConfirmS] = useState(0)

    const [totaldipos_ConfirmS, settotaldipos_ConfirmS] = useState(0);
    const [ZJItax_ConfirmS, setZJItax_ConfirmS] = useState(0)
    const [countCancle_ConfirmS, setcountCancle_ConfirmS] = useState(0)



    const [modal_setswitchStatus__ConfirmS, sets_modalwitchStatus_ConfirmS] = useState(false);
    const [switchStatus_ConfirmS_data, setswitchStatus_ConfirmS_data] = useState({});

    const [modal_show_alldetail, setmodal_show_alldetail] = useState(false);



    const [modalWhere, setmodalWhere] = useState(null)
    const [pdfDatas, setpdfDatas] = useState(true)


    const [commission, setcommission] = useState(0)
    const [commission_percen, setcommission_percen] = useState(0)
    const [diposit, setdiposit] = useState(0)
    const [diposit_percen, setdiposit_percen] = useState(0)


    const [thirdcover_option, setthirdcover_option] = useState([])
    const [drivercover_option, setdrivercover_option] = useState([])
    const [getOneFull, setgetOneFull] = useState({})



    const [updateCommit, setupdateCommit] = useState(false)
    const [premuim, setpremuim] = useState(0)
    const [Total_MVL, setTotal_MVL] = useState(0)
    const [paylate, setpaylate] = useState(0)
    const [Diposit, setDiposit] = useState(0)
    const [Text116, setText116] = useState(0)
    const [enable_pay_late, setenable_pay_late] = useState(0)
    const [commission_update, setcommission_update] = useState(0)
    const [commission_percen_update, setcommission_percen_update] = useState(0)
    const [diposit_update, setdiposit_update] = useState(0)
    const [diposit_percen_update, setdiposit_percen_update] = useState(0)

    useEffect(e => {
        // ເປີເຊັນການຂາຍເປັນເປີເຊັນ
        let late = enable_pay_late === 1 ? 0 : paylate
        let compercen = Total_MVL - late
        // ເປີເຊັນການຂາຍເປັນເງິນກ່ອນຫັກອາກອນ
        let com = premuim * ((Total_MVL - late) / 100)
        // ຫັກອອກອນອອກ 5ເປີເຊັນ
        let comTax = com - (com * (Text116 / 100))

        //ເປີເຊັນເງິນຝາກ
        let di = Diposit
        //ເປີເຊັນເງິນຝາກເປັນເງິນ
        let dim = (comTax * (di / 100)) / (compercen / 100)

        // ເປັນເຊັນການຂາຍໃດ້ຮັບຕົວຈິງ
        let totalpercen = comTax - dim
        setcommission_update(totalpercen)
        setcommission_percen_update(compercen)

        setdiposit_update(dim)
        setdiposit_percen_update(di)

    }, [Total_MVL, paylate, Diposit, Text116])


    //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນບຸກຄຸນທີສາມ
    useEffect(() => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        // fetch(ip + "sell_online/thirdcover_option", requestOptions)
        fetch(ip + "sell_online/cover_third_tariff", requestOptions)
            .then(response => response.json())
            .then(result => {
                setthirdcover_option(result.data.data)
            })
            .catch(error => console.log('error', error));
    }, [])

    const getUser = useCallback(async () => {
        let all = {
            id: 0,
            name: 'ຕົວແທນທັງໝົ້ດ'
        }
        let link = `${ip}sell_online/users`
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        try {
            const response = await fetch(link, requestOptions);
            const result_1 = await response.json();
            if (result_1.status === 200) {
                if (level === 'manager' || level === "acc") {
                    let u = result_1.data;
                    u.unshift(all);
                    setUsers(u);
                } else {
                    const uu = result_1.data.find(id => id.id === user_id);
                    setUsers([uu]);
                }

            } else {
            }
        } catch (error) {
            return console.log('error', error);
        }

    }, [level, user_id])

    function onchange_user(value) {
        let name = (users.find(e => e.id === value))
        setsent_user_name(name.name)
        setsent_user(value)
    }
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    function getOneDatas() {
        let link = `${ip}sell_online/getBetween`
        console.log('getOneDatas')
        let dataSetForGet = {
            no_start: policy_no_start,
            no_end: policy_no_end,
            sent_user: sent_user,
        }
        function setWhenUpdate(result) {
            if (result.data.status === 200) {
                const { rows, total } = result.data
                // console.log(268)
                console.log(rows)
                if (rows.length > 0) {
                    let cancel = 0
                    let de = rows.map(e => {
                        cancel += countCanclePolicy(e.cancel)
                        return e
                    })

                    settotal_premuim_ConfirmS(total.total_Net_premuim)
                    setpremuim_ConfirmS(total.total_premuim)
                    setcommission_ConfirmS(total.total_AjentCommission)
                    setZJIIncom_ConfirmS(total.zjiIncom)
                    settotal_zji_get_ConfirmS(total.total_zji_get)
                    settotaldipos_ConfirmS(total.totaldipos)
                    setZJItax_ConfirmS(total.total_tax)
                    setcountCancle_ConfirmS(cancel)
                    setdatas(de)
                    // console.log(de)
                } else {
                    setdatas([])
                    message.success(`ບໍ່ພົບເລກທີສັນຍາ ${policy_no_start} -  ${policy_no_end}ໃນລະບົບ`);
                }
                setTimeout(() => {
                    setloading(false)
                }, 100);
            } else {
                setTimeout(() => {
                    setloading(false)
                }, 100);
            }
        }
        if (policy_no_start > policy_no_end) {
            message.error('ເລກເລີ່ມຕົ້ນຄວນຈະນ້ອຍກວ່າເລກສິ້ນສຸດ')
        } else {
            setloading(true)
            postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
        }

    }

    //ຟັ່ງຊັ່ນບັນທຶກຢືນຢັນການຮັບເງິນ
    const handleOk = () => {
        console.log(' ຟັ່ງຊັ່ນບັນທຶກຢືນຢັນການຮັບເງິນ')
        setIsModalVisible(false);
        let link = `${ip}sell_online/confirm`
        let dataSetForGet = null
        if (updateCommit) {
            dataSetForGet = {
                detial: moment(Date.now()).format(dateFormat)
                    + '=>'
                    + 'ຄອມ' + commission_percen_update + '/'
                    + 'ຝາກ' + Diposit + '/'
                    + 'ອາກອນ' + Text116 + '/'
                    + detial,
                confirm_user: user,
                no: no,
                commission: commission_update,
                commission_percen: commission_percen_update,
                diposit_percen: diposit_percen_update,
                diposit: diposit_update
            }
        } else {
            dataSetForGet = {
                detial: moment(Date.now()).format(dateFormat) + '=>' + detial,
                confirm_user: user,
                no: no,
                commission: commission,
                commission_percen: commission_percen,
                diposit_percen: diposit_percen,
                diposit: diposit

            }
        }

        function setWhenUpdate(result) {
            if (result.data.data.changedRows === 1) {
                message.info('ຢືນຢັນການຮັບເງິນສຳເຫຼັ້ດ')
                setupdateCommit(false)
                setdetial(null);
                setno(null);
                setdetial('')
                if (modalWhere === 'getOneDatas') {
                    getOneDatas()
                } else if (modalWhere === 'getOneDataDate') {
                    // getOneDataDate()
                } else if (modalWhere === 'getallByAjent') {
                    // getallByAjent()
                }
            } else {
                message.error('ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່')
            }

        }
        // console.log(dataSetForGet)
        postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
    };

    function showModalDetail(no) {
        setno(no)
        setmodal_show_alldetail(true)
        getDataOneFull(no)
    }

    function getDataOneFull(no) {
        console.log('getDataOneFull')
        let link = `${ip}sell_online/getOneFull`
        let dataSetForGet = { no: no }
        function setWhenUpdate(result) {
            // setloading(true)
            if (result.data.status === 200) {
                const { rows } = result.data

                if (rows.length > 0) {

                    let de = rows.map(e => {

                        return e

                    })
                    setgetOneFull(de[0])

                } else {
                    setgetOneFull({})
                }
                setTimeout(() => {
                    // setloading(false)
                }, 100);
            } else {
                setTimeout(() => {
                    // setloading(false)
                }, 100);
            }
        }
        postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)

    }



    useEffect(() => {
        getUser()
    }, [getUser])



    return (
        <>
            <MenuBar />
            <div className="container text-center mt-3">
                <h4>ຢືນຢັນການຮັບເງິນ ສັນຍາ ປະກັນໄພລົດ</h4>
            </div>
            <div className="container-fluid"
                style={{
                    paddingBottom: 10
                }}
            >
                <Tabs defaultActiveKey="1" onChange={(e) => { }}>
                    <TabPane tab="ການຄົ້ນຫາດ້ວຍເລກທີສັນຍາ" key="1">
                        {ConfirmS()}
                    </TabPane>

                </Tabs >
            </div >
            <Modal
                // width={1000}
                title={"ຟອມຢືນຢັນຮັບເງິນສັນຍາເລກທີ: " + pad(no)}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={[
                    <Button
                        key="back"
                        type="primary"
                        onClick={handleCancel}>
                        ກັບຄືນ
                    </Button>,
                    detial !== '' && <Button key="submit" danger onClick={() => handleOk()}>
                        ຢືນຢັນການຮັບເງິນ
                    </Button>
                ]}
            >
                ແກ້ໄຂຄ່າຄອມມິດຊັ່ນ: {"   "}
                <Switch
                    checkedChildren="ຖືກເປີດ"
                    unCheckedChildren="ຖືກປິດ"
                    // defaultChecked
                    checked={updateCommit}
                    onChange={e => {
                        setupdateCommit(e)
                    }}
                />
                {updateCommit ?
                    <ul>
                        <li>
                            ເປີເຊັນຕົວແທນ
                            ຄ່າຄອມ <InputNumber
                                onChange={(e) => {
                                    setTotal_MVL(e)
                                }}
                                size='small'
                                value={Total_MVL}
                            />%



                        </li>
                        <li>
                            ຈ່າຍຊ້າ  <InputNumber
                                size='small' value={paylate} disabled />%
                        </li>   <li>
                            ເງິນຝາກ<InputNumber
                                onChange={(e) => {
                                    setDiposit(e)
                                }}
                                size='small' value={Diposit} />%
                        </li>


                        <li>
                            ເປີເຊັນຂາຍສຸດທິ: {format(commission_percen_update)}
                        </li>

                        <li>
                            ຫັກອາກອນລາຍໄດ້:  <InputNumber size='small' value={Text116}
                                onChange={(e) => {
                                    setText116(e)
                                }}
                            /> %
                        </li>
                        <li>
                            ເປັນເງິນຮັບສຸດທິ: {format(commission_update)}
                        </li>


                    </ul>
                    :
                    null}
                <br />
                ກະລຸນາໃສ່ລາຍລະອຽດ ການຢືນຢັນຮັບເງິນ
                <TextArea
                    placeholder="ກະລຸນາໃສ່ລາຍລະອຽດ ການຢືນຢັນຮັບເງິນ"
                    showCount
                    maxLength={150}
                    value={detial}
                    onChange={e => setdetial(e.target.value)}
                />
            </Modal>

            <Modal
                width={800}
                title={"ລາຍລະອຽດຂອງສັນຍາເລກທີ " + pad(switchStatus_ConfirmS_data.no)}
                visible={modal_setswitchStatus__ConfirmS}
                onOk={() => sets_modalwitchStatus_ConfirmS(false)}
                onCancel={() => sets_modalwitchStatus_ConfirmS(false)}
                footer={[
                    <Button key="back" onClick={() => sets_modalwitchStatus_ConfirmS(false)}>
                        ກັບຄືນ
                    </Button>

                ]}
            >
                <>
                    <div>

                    </div>
                    {gotoMakePDF(switchStatus_ConfirmS_data.cover) === "L" ?
                        <MakeDocLong
                            no={switchStatus_ConfirmS_data.no}
                            user={user}
                            oneData={switchStatus_ConfirmS_data}
                            thirdcover_option={thirdcover_option}
                            drivercover_option={drivercover_option}
                        />
                        :
                        <MakeDocSafty
                            no={switchStatus_ConfirmS_data.no}
                            oneData={switchStatus_ConfirmS_data}
                        />
                    }

                </>
            </Modal>
            <ShowModalPolicy
                no={no}
                modal_show_alldetail={modal_show_alldetail}
                setmodal_show_alldetail={setmodal_show_alldetail}
                getOneFull={getOneFull}
            />

        </>
    )

    // function string() {
    //     let txt = 'ບໍລິສັດ ເອເຊຍລົງທືນພັດທະນາ ແລະ ກໍ່ສ້າງ ຈໍາກັດຜູ້ດຽວ (AIDC)'
    //     let long_txt = 15
    //     let count_txt = txt.length
    //     let data = []
    //     for (let a = 0; a <= count_txt; a += long_txt) {
    //         data.push(<p>{txt.substring((a === 0 ? 0 : a), (a + long_txt))}</p>)
    //     }
    //     return data
    // }
    function ConfirmS() {


        return (
            <>
                <div className="container">
                    {loading && <div style={{
                        position: 'absolute',
                        top: '11%',
                        left: '45%'
                    }}>
                        <Spin tip="ກຳລັງໂຫລດຂໍ້ມູນ..." />
                    </div>}


                    {/* {string()} */}
                    <Select
                        placeholder="ເລືອກຕົວແທນ"
                        optionFilterProp="children"
                        style={{ width: '100%', marginBottom: 5 }}
                        onChange={onchange_user}
                    >
                        {
                            users.map(value => {
                                return (
                                    <Option key={value.id} value={value.id}>{value.name + " "} {value.user === undefined ? null : value.user} </Option>

                                )
                            })
                        }
                    </Select>
                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 5 }}>
                        <div style={{ flex: 4 }}>
                            <InputNumber
                                style={{ width: '100%' }}
                                onChange={(v) => setpolicy_no_start(v)}
                                placeholder='ໃສ່ເລກທີສັນຍາເລີ່ມຕົ້ນ'
                            />

                        </div>
                        <div style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div>
                                ຫາ
                            </div>
                        </div>
                        <div style={{ flex: 4 }}>
                            <InputNumber
                                style={{ width: '100%' }}
                                onChange={(v) => setpolicy_no_end(v)}
                                placeholder='ໃສ່ເລກທີສັນຍາສິ້ນສຸດ'
                            />

                        </div>
                        <div style={{ flex: 2, marginLeft: 5 }}>
                            <Button
                                disabled={policy_no_start > 0 ? (policy_no_end > 0 ? false : true) : true} onClick={() => {
                                    getOneDatas()
                                }} style={{ width: '100%' }} type='primary'> ຄົ້ນຫາດ້ວຍເລກທີສັນຍາ </Button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>ຕົວແທນຂາຍ</th>
                                <th>ເລກທີສັນຍາ</th>
                                <th>ເລກທະບຽນ</th>
                                <th>ວັນທີສິ້ນສຸດການຄຸ້ມກັນ</th>
                                <th>ຊື່ລູກຄ້າ</th>
                                <th>ລາຍຮັບທັງໝົ້ດ</th>
                                <th>ກ່ອນອາກອນ</th>
                                <th>ເປີເຊັນຕົວແທນ (ຄ່າຄອມ-ຈ່າຍຊ້າ)</th>
                                <th>ເງິນຝາກຄັງ</th>
                                <th>
                                    ລາຍຮັບຕົວແທນຫັກອາກອນແລ້ວ</th>
                                <th>ລາຍຮັບເຂົ້າ ZJI</th>
                                <th>ມອບເຂົ້າ ZJI ສຸດທິ</th>
                                <th>ວັນທີຄ້າງຈ່າຍ</th>
                                <th>ສະຖານະການຊຳລະໃຫ້ຕົວແທນ</th>
                                <th>ສະຖານະການຊຳລະໃຫ້ສຳນັກງານ</th>
                                <th>ສະຖານະຂອງສັນຍາ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                datas.map((oneData, key) => {
                                    // console.log('915')
                                    // console.log(oneData)
                                    return (
                                        <tr key={key}>
                                            <td>{key + 1}</td>
                                            <td>
                                                {oneData.userText}
                                            </td>
                                            <td>
                                                <Button
                                                    onClick={() => {
                                                        sets_modalwitchStatus_ConfirmS(true)
                                                        setswitchStatus_ConfirmS_data(oneData)
                                                        getOptionDriver(oneData, setdrivercover_option)
                                                    }
                                                    }>{oneData.policy_type === 'MS' ? 'MS-' : null}{pad(oneData.no)}
                                                </Button>
                                            </td>
                                            <td>{oneData.o_plate}</td>
                                            <td>{moment(oneData.end).format('DD-MM-YYYY HH:mm:ss')}</td>
                                            <td>{oneData.o_name}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                {format(oneData.total_premuim)}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {/* ກ່ອນອາກອນ */}
                                                {format(oneData.premuim)}
                                            </td>
                                            <td style={{ textAlign: "right", ...(oneData.enable_pay_late === 1 ? { color: "orange" } : {}) }}>
                                                {/* ເປີເຊັນຕົວແທນ */}
                                                {/* {oneData.Total_MVL}  */}
                                                (
                                                {
                                                    oneData.paid === 1 ? oneData.commission_percen : format(oneData.Total_MVL) + "-" + oneData.paylate
                                                }
                                                )% =
                                                {
                                                    format(oneData.agentCommit)
                                                }
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                {/* ເງິນຝາກຄັງ */}

                                                {oneData.paid === 1 ? oneData.diposit_percen : (oneData.Diposit)}% =  {format(oneData.depos)}

                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {/* ຫັກອາກອນ 5  % */}
                                                {
                                                    format(oneData.Text116)
                                                }
                                                % =
                                                {
                                                    format(oneData.tex)
                                                }
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {/* ລາຍຮັບເຂົ້າ ZJI */}
                                                {
                                                    format(oneData.ZJIIncom)
                                                }
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {/* ລາຍຮັບເຂົ້າ ZJI ສຸດທິ */}
                                                {
                                                    format(oneData.ZJIIncom + oneData.depos)
                                                }
                                            </td>
                                            <td>
                                                {format(oneData.day)} ວັນ
                                            </td>
                                            <td>
                                                {oneData.emp_paid === 1 ? <Tag style={{ cursor: 'pointer' }} color="geekblue">ການຊຳລະສົມບູນ</Tag> : <Tag style={{ cursor: 'pointer' }} color="red">ລໍຖ້າການຊຳລະ</Tag>}
                                            </td>

                                            <td>
                                                {oneData.paid === 1 ? <Tag style={{ cursor: 'pointer' }} color="geekblue" onClick={() => showModalDetail(oneData.no)}>ການຊຳລະສົມບູນ</Tag> : <Tag style={{ cursor: 'pointer' }} color="red" onClick={() => showModalDetail(oneData.no)}>ລໍຖ້າການຊຳລະ</Tag>}
                                            </td>
                                            <td>
                                                {oneData.cancel === 1 ? <Tag style={{ cursor: 'pointer' }} onClick={() => handleClick(oneData.no)} color="red">ຖືກຍົກເລີກ</Tag> : <Tag style={{ cursor: 'pointer' }} onClick={() => handleClick(oneData.no)} color="geekblue">ບໍ່ຖືກຍົກເລີກ</Tag>}
                                            </td>
                                            <td>
                                                <Button danger onClick={() => {
                                                    setno(oneData.no)
                                                    showModal()
                                                    setmodalWhere('getOneDatas')
                                                    setpdfDatas(true)
                                                    if (oneData.enable_pay_late === 1) {
                                                        setcommission(oneData.tex)
                                                        setcommission_percen(oneData.Total_MVL)

                                                        setcommission_update(oneData.tex)
                                                        setcommission_percen_update(oneData.Total_MVL)
                                                    } else {
                                                        setcommission(oneData.tex)
                                                        setcommission_percen(oneData.Total_MVL - oneData.paylate)

                                                        setcommission_update(oneData.tex)
                                                        setcommission_percen_update(oneData.Total_MVL - oneData.paylate)
                                                    }
                                                    setdiposit(oneData.depos)
                                                    setdiposit_percen(oneData.Diposit)
                                                    setpremuim(oneData.premuim)
                                                    setTotal_MVL(oneData.Total_MVL)
                                                    setpaylate(oneData.paylate)
                                                    setDiposit(oneData.Diposit)
                                                    setText116(oneData.Text116)
                                                    setenable_pay_late(oneData.enable_pay_late)




                                                    //    ----------------------------- ອັບເດດຄ່າຄອມ
                                                }}
                                                    disabled={oneData.paid === 1 ? true : false}
                                                >
                                                    ຢືນຢັນ
                                                </Button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                        {
                            datas.length > 0 && <tfoot>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th style={{ textAlign: 'right' }}>{format(total_premuim_ConfirmS)}</th>
                                    <th style={{ textAlign: 'right' }}>{format(premuim_ConfirmS)}</th>
                                    <th style={{ textAlign: 'right' }}>{format(commission_ConfirmS)}</th>
                                    <th style={{ textAlign: 'right' }}>{format(totaldipos_ConfirmS)}</th>
                                    <th style={{ textAlign: 'right' }}>{format(ZJItax_ConfirmS)}</th>
                                    <th style={{ textAlign: 'right' }}>{format(ZJIIncom_ConfirmS)}</th>
                                    <th style={{ textAlign: 'right' }}>{format(total_zji_get_ConfirmS)}</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </tfoot>
                        }

                    </table>

                </div>
                {datas.length > 0 && showRoportDetail(
                    total_premuim_ConfirmS,
                    ZJItax_ConfirmS,
                    ZJIIncom_ConfirmS,
                    (datas.length > 0 ? datas.length : 0),
                    countCancle_ConfirmS,
                    total_zji_get_ConfirmS
                )}
                {/* {

                    datas.length > 0 &&
                    <Button type='primary' >
                        <PDFDownloadLink document={
                            <PDFReport
                                datas={datas}
                                total_premuim_ConfirmS={total_premuim_ConfirmS}
                                premuim_ConfirmS={premuim_ConfirmS}
                                commission_ConfirmS={commission_ConfirmS}
                                ZJIIncom_ConfirmS={ZJIIncom_ConfirmS}
                                ZJItax_ConfirmS={ZJItax_ConfirmS}
                                countCancle_ConfirmS={countCancle_ConfirmS}
                                policy_no_start={policy_no_start}
                                policy_no_end={policy_no_end}
                                sent_user_name={sent_user_name}

                            />} fileName={'ລາຍລະອຽດຕົວແທນ ' + sent_user + '/' + user + moment(Date.now()).format('DD-MM-YYYY') + ".pdf"}>
                            {({ blob, url, loading, error }) =>
                                loading ? 'ກຳລັງດາວໂຫລດ...' : 'ລາຍງານເປັນ PDF'
                            }
                        </PDFDownloadLink>
                    </Button>
                } */}
                {datas.length > 0 && pfd()}
            </>
        )
        function pfd() {
            if (pdfDatas) {
                return (
                    <Button type='primary'
                        style={{
                            background: "#FCF3CF",
                            borderColor: "#F7DC6F",
                            color: '#566573',

                        }}
                        onClick={() => setpdfDatas(!pdfDatas)}
                    >
                        ສ້າງ PDF
                    </Button>
                )
            } else {
                return (
                    <Button type='primary'
                        onClick={() => setpdfDatas(!pdfDatas)}
                    >
                        <PDFDownloadLink document={
                            <PDFReport
                                user={user}
                                datas={datas}
                                total_premuim_ConfirmS={total_premuim_ConfirmS}
                                premuim_ConfirmS={premuim_ConfirmS}
                                commission_ConfirmS={commission_ConfirmS}
                                ZJIIncom_ConfirmS={ZJIIncom_ConfirmS}
                                total_zji_get_ConfirmS={total_zji_get_ConfirmS}
                                totaldipos_ConfirmS={totaldipos_ConfirmS}
                                ZJItax_ConfirmS={ZJItax_ConfirmS}
                                countCancle_ConfirmS={countCancle_ConfirmS}
                                policy_no_start={policy_no_start}
                                policy_no_end={policy_no_end}
                                sent_user_name={sent_user_name}
                                where={'s'}
                            />} fileName={'ລາຍລະອຽດຕົວແທນ ' + sent_user + '/' + user + moment(Date.now()).format('DD-MM-YYYY') + ".pdf"}>
                            {({ blob, url, loading, error }) =>
                                loading ? 'ກຳລັງດາວໂຫລດ...' : 'ລາຍງານເປັນ PDF'
                            }
                        </PDFDownloadLink>
                    </Button>
                )
            }

        }
    }



    function handleClick(no) {
        window.open(QR + no);
    }

}

export default ConfirmPaid

export function showRoportDetail(total_premuim, commission, ZJIIncom, countTotal, countCancle, total_get_ZJIIncom) {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-4">
                    <ul className="list-group">
                        <li className="list-group-item">
                            ຈຳນວນເງິນລາຍຮັບຕາມສັນຍາ {format(total_premuim)}

                        </li>
                        <li className="list-group-item">
                            ຈຳນວນເງິນທີຕົວແທນໄດ້ຮັບ {format(commission)}

                        </li>
                        <li className="list-group-item">
                            ຈຳນວນເງິນທີ ZJI ໄດ້ຮັບ {format(ZJIIncom)}

                        </li>
                        <li className="list-group-item">
                            ຈຳນວນເງິນທີ ZJI ໄດ້ຮັບສຸດທິ {format(total_get_ZJIIncom)}

                        </li>
                    </ul>
                </div>
                <div className="col-sm-4">
                    <ul className="list-group">
                        <li className="list-group-item">ຈຳນວນສັນຍາທັງໝົດ {countTotal}
                        </li>
                        <li className="list-group-item">ສັນຍາຖືກຍົກເລີກ {countCancle}
                        </li>
                    </ul>
                </div>
                <div className="col-sm-4">

                    <ul className="list-group">
                        <li className="list-group-item">
                            45 ວັນຂື້ນໄປ ຖືກລົບ 1%
                        </li>
                        <li className="list-group-item">
                            60 ວັນຂື້ນໄປ ຖືກລົບ 2%
                        </li>
                        <li className="list-group-item">
                            90 ວັນຂື້ນໄປ ຖືກລົບ 5%
                        </li>
                        <li className="list-group-item">
                            120 ວັນຂື້ນໄປ ຖືກຍົກເລີກ ຄ່ານາຍໜ້າ
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    )
}
